import React from 'react';
import { motion } from 'framer-motion';
import PromptCard from './PromptCard';

const PromptList = ({ prompts }) => {
  if (!prompts || prompts.length === 0) return null;

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="mt-16 w-full max-w-7xl mx-auto"
    >
      <div className="flex items-center justify-between mb-8 px-4">
        <h2 className="text-2xl font-bold text-stone-800">
          Generated Prompts <span className="text-orange-500 font-medium text-lg ml-2">({prompts.length})</span>
        </h2>
        <p className="text-stone-500 text-sm hidden sm:block">Click copy to use in Suno V5</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-4">
        {prompts.map((prompt, index) => (
          <PromptCard key={index} prompt={prompt} index={index} />
        ))}
      </div>
    </motion.div>
  );
};

export default PromptList;